import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('high_noon', {
  cherry: 'cowboy_boot',
  lemon: 'bandana',
  orange: 'tumbleweed',
  bell: 'town_bell',
  star: 'duel_wild',
  seven: 'clock_tower',
  gem: 'red_jasper',
  scatter: 'cactus_flower_scatter',
  money: 'hat_of_gold',
});

/** High Noon — GENERATED by scaffoldSlot from
 *  content/slots/high_noon.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const HIGH_NOON_THEME: Theme = {
  id: 'high_noon',
  name: 'High Noon',
  palette: {
    accent: 0xc25a3f,
    secondary: 0xe89a5c,
    warm: 0xf2d27a,
    frameFill: 0x2a160f,
    bgGradientTop: 0x5a2e1c,
    bgGradientBottom: 0x1c0d08,
    dimOverlay: 0x0d0604,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Cowboy Boot', glyph: '🥾', tint: 0x8a5a3a, weight: 5, textureAlias: 'high_noon:cherry',
        winVideoAlias: 'high_noon:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Bandana', glyph: '🔻', tint: 0xc0392b, weight: 5, textureAlias: 'high_noon:lemon',
        winVideoAlias: 'high_noon:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Tumbleweed', glyph: '🌾', tint: 0xb08a4a, weight: 4, textureAlias: 'high_noon:orange',
        winVideoAlias: 'high_noon:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Town Bell', glyph: '🔔', tint: 0xd0a84e, weight: 3, textureAlias: 'high_noon:bell',
        winVideoAlias: 'high_noon:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'High Noon', glyph: '🌞', tint: 0xf0a040, weight: 2, textureAlias: 'high_noon:star',
        winVideoAlias: 'high_noon:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Showdown', glyph: '🕛', tint: 0xc0a060, weight: 2, textureAlias: 'high_noon:seven',
        winVideoAlias: 'high_noon:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Jasper', glyph: '💎', tint: 0xb03a2a, weight: 2.5, textureAlias: 'high_noon:gem',
        winVideoAlias: 'high_noon:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Cactus Flower', glyph: '🌸', tint: 0xd85a7a, weight: 0.5, textureAlias: 'high_noon:scatter',
        winVideoAlias: 'high_noon:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Showdown Pot', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'high_noon:money',
        winVideoAlias: 'high_noon:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x2a160f, multiplier: 0, weight: 4 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xc25a3f, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x2a160f, multiplier: 0, weight: 3 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xe89a5c, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xc25a3f, multiplier: 1, weight: 3 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x0-c', kind: 'multiplier', label: '✕', tint: 0x2a160f, multiplier: 0, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xc25a3f, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x25-a', kind: 'multiplier', label: '×25', tint: 0xf2d27a, multiplier: 25, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'high_noon:bg', path: 'environment/high_noon.png' },
      columnBackground: { alias: 'high_noon:column_bg', path: 'reel/high_noon_column_bg.png' },
      border: { alias: 'high_noon:border', path: 'brand/border_frontier.png' },
    },
  },
};
